import { render, staticRenderFns } from "./CompanyNewsDetail.vue?vue&type=template&id=9b061e2c"
import script from "./CompanyNewsDetail.vue?vue&type=script&lang=js"
export * from "./CompanyNewsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports